// Constantes

/**
 * API base URL
 */
// export const BASE_URL = process.env.REACT_APP_API_URL;
export const BASE_URL = import.meta.env.VITE_API_URL;
export const API_HOST = import.meta.env.VITE_API_HOST;
export const APP_QA = import.meta.env.VITE_APP_QA;
export const VITE_CLARITY_PROJECT_ID = import.meta.env.VITE_CLARITY_PROJECT_ID;
export const AUTH_URL = import.meta.env.VITE_AUTH_URL;
export const APP_VERSION = import.meta.env.VITE_APP_VERSION;

// process.env. REACT_APP_AUTH_URL
// export const API_HOST = process.env.REACT_APP_API_HOST;
//export const BASE_URL = "http://localhost:8002/api/v1/";

// export const WS_URL = process.env.REACT_APP_WS_URL;

/**
 * Genders list for dropdowns
 */
export const GENDERS = [
  { label: 'Masculino', value: 'M' },
  { label: 'Femenino', value: 'F' },
];

export const CONDITIONS = [
  { label: 'Activo', value: 'A' },
  { label: 'Jubilado', value: 'J' },
  { label: 'Sobreviviente', value: 'S' },
];

/**
 * Resuelve el código corto de condición (A/J/S) a su label completo.
 * Si el código no está en CONDITIONS, devuelve el código tal cual.
 */
export function formatCondition(code) {
  if (!code) return null;
  const match = CONDITIONS.find(c => c.value === code);
  return match ? match.label : code;
}
/**
 * Phone codes for dropdowns
 */
export const PHONE_CODES = [
  { label: '0412', value: '58412' },
  { label: '0414', value: '58414' },
  { label: '0416', value: '58416' },
  { label: '0424', value: '58424' },
  { label: '0426', value: '58426' },
  { label: '0422', value: '58422' },
];

/**
 * Months list for dropdowns
 */
export const MONTHS = [
  { label: 'Enero', value: 1 },
  { label: 'Febrero', value: 2 },
  { label: 'Marzo', value: 3 },
  { label: 'Abril', value: 4 },
  { label: 'Mayo', value: 5 },
  { label: 'Junio', value: 6 },
  { label: 'Julio', value: 7 },
  { label: 'Agosto', value: 8 },
  { label: 'Septiembre', value: 9 },
  { label: 'Octubre', value: 10 },
  { label: 'Noviembre', value: 11 },
  { label: 'Diciembre', value: 12 },
];

/**
 * List of user roles for dropdowns
 */
export const USER_ROLES_DROPDOWN = [
  { label: 'Conciliador', value: 'conciliator' },
  { label: 'Auditor', value: 'auditor' },
  { label: 'Gerente general', value: 'manager' },
  { label: 'Analista regional', value: 'analyst' },
  { label: 'Proveedor', value: 'medicalCenter' },
];

/**
 * List of day numbers with labels
 */
export const DAYS = [
  { id: 1, shortLabel: 'Lun.', fullLabel: 'Lunes', apiLabel: 'lunes' },
  { id: 2, shortLabel: 'Mar.', fullLabel: 'Martes', apiLabel: 'martes' },
  { id: 3, shortLabel: 'Mie.', fullLabel: 'Miércoles', apiLabel: 'miércoles' },
  { id: 4, shortLabel: 'Jue.', fullLabel: 'Jueves', apiLabel: 'jueves' },
  { id: 5, shortLabel: 'Vie.', fullLabel: 'Viernes', apiLabel: 'viernes' },
  { id: 6, shortLabel: 'Sab.', fullLabel: 'Sábado', apiLabel: 'sábado' },
  { id: 7, shortLabel: 'Dom.', fullLabel: 'Domingo', apiLabel: 'domingo' },
];

/**
 * List of possible medical case file types
 */
export const MEDICAL_FILE_TYPES = [
  { label: 'Orden médica', value: 'orden_medica' },
  { label: 'Examen médico', value: 'examen_medico' },
  { label: 'Resultado de examen', value: 'resultado_examen' },
  { label: 'Receta médica', value: 'receta_medica' },
  { label: 'Estudio médico', value: 'estudio_medico' },
  { label: 'Cédula', value: 'cedula' },
  { label: 'Ficha del titular', value: 'ficha_titular' },
  { label: 'Informe médico', value: 'informe_medico' },
  { label: 'Imagenología', value: 'imagenologia' },
  { label: 'Otro', value: 'otro' },
];

/**
 * List of possible status of the medical staff of a medical center
 */
export class MedicalStaffStatus {
  static TOTAL = 'total';
  static ASIGNADOS = 'assigned';
  static SIN_ASIGNAR = 'not_assigned';

  static colors = {
    [MedicalStaffStatus.TOTAL]: '#a1a1a1',
    [MedicalStaffStatus.ASIGNADOS]: '#84cc16',
    [MedicalStaffStatus.SIN_ASIGNAR]: '#f0b100',
  };

  static getColor(status) {
    return MedicalStaffStatus.colors[status] || 'transparent';
  }

  static labels = {
    [MedicalStaffStatus.TOTAL]: 'Total',
    [MedicalStaffStatus.ASIGNADOS]: 'Asignado',
    [MedicalStaffStatus.SIN_ASIGNAR]: 'Sin asignar',
  };
  static getLabel(status) {
    return MedicalStaffStatus.labels[status] || 'Desconocido';
  }
}

/**
 * Class of available medical case status
 */
export class CaseStatus {
  static PENDIENTE = 'pendiente';
  static RESCHEDULED = 'agendado';
  static REMESADO = 'remesado';
  static ATENDIDO = 'atendido';
  static CONCILIADO = 'conciliado';
  static AUDITADO = 'auditado';
  static ANULADO = 'anulado';
  static TO_REVIEW = 'en_revision';
  static TO_SUBSCRIBE = 'por_suscribir';
  static WITHOUT_FUNDS = 'sin_fondo';
  static TO_BE_REVIEWED = 'por_revisar';
  static PRIORITIZED = 'priorizado';
  static REASSIGNED = 'reassigned';
  static FIELD_CHANGED = 'field_changed';
  static REQUESTED = 'solicitado';
  static PAID = 'pagado';
  static CHARGED = 'cobrado';
  static SERVICE_ORDER = 'orden_de_servicio';

  static colors = {
    [CaseStatus.TO_REVIEW]: '#a1a1a1',
    [CaseStatus.TO_SUBSCRIBE]: '#f0b100',
    [CaseStatus.ATENDIDO]: '#84cc16',
    [CaseStatus.REMESADO]: '#0ea5e9',
    [CaseStatus.RESCHEDULED]: '#14b8a6',
    [CaseStatus.PENDIENTE]: '#f97316',
    [CaseStatus.CONCILIADO]: '#7e22ce',
    [CaseStatus.AUDITADO]: '#22c55e',
    [CaseStatus.ANULADO]: '#ef4444',
    [CaseStatus.WITHOUT_FUNDS]: '#ff6467',
    [CaseStatus.TO_BE_REVIEWED]: '#eab308',
    [CaseStatus.PRIORITIZED]: '#499fd8',
    [CaseStatus.REASSIGNED]: '#4d179a',
    [CaseStatus.FIELD_CHANGED]: '#6b7280',
    [CaseStatus.REQUESTED]: '#a1a1a1',
    [CaseStatus.PAID]: '#16a34a',
    [CaseStatus.CHARGED]: '#007595',
    [CaseStatus.SERVICE_ORDER]: '#e17100',
  };

  static getColor(status) {
    return CaseStatus.colors[status] || 'transparent';
  }

  static labels = {
    [CaseStatus.PRIORITIZED]: 'Priorizado',
    [CaseStatus.PENDIENTE]: 'Pendiente',
    [CaseStatus.RESCHEDULED]: 'Agendado',
    [CaseStatus.REMESADO]: 'Remesado',
    [CaseStatus.ATENDIDO]: 'Atendido',
    [CaseStatus.ANULADO]: 'Anulado',
    [CaseStatus.CONCILIADO]: 'Conciliado',
    [CaseStatus.AUDITADO]: 'Auditado',
    [CaseStatus.TO_REVIEW]: 'Revisión',
    [CaseStatus.TO_SUBSCRIBE]: 'Por Suscribir',
    [CaseStatus.WITHOUT_FUNDS]: 'Sin Fondo',
    [CaseStatus.TO_BE_REVIEWED]: 'Por Revisar',
    [CaseStatus.REASSIGNED]: 'Reasignado',
    [CaseStatus.FIELD_CHANGED]: 'Editado',
    [CaseStatus.REQUESTED]: 'Solicitado por Paciente',
    [CaseStatus.PAID]: 'Pagado',
    [CaseStatus.CHARGED]: 'Cobrado',
    [CaseStatus.SERVICE_ORDER]: 'Orden de Servicio',
  };

  static getLabel(status) {
    return CaseStatus.labels[status] || 'Desconocido';
  }

  /**
   * Status que un superusuario puede asignar manualmente a un caso
   * (endpoint `edit_status`, sin restricciones de transición).
   */
  static adminEditable = [
    CaseStatus.TO_REVIEW,
    CaseStatus.REQUESTED,
    CaseStatus.PENDIENTE,
    CaseStatus.RESCHEDULED,
    CaseStatus.ATENDIDO,
    CaseStatus.REMESADO,
    CaseStatus.CONCILIADO,
    CaseStatus.AUDITADO,
    CaseStatus.TO_BE_REVIEWED,
    CaseStatus.ANULADO,
    CaseStatus.TO_SUBSCRIBE,
    CaseStatus.WITHOUT_FUNDS,
    CaseStatus.PAID,
    CaseStatus.CHARGED,
    CaseStatus.SERVICE_ORDER,
  ];
}

/**
 * Class of available medical case invoice status
 */
export class CaseInvoiceStatus {
  static PENDING = 'pending';
  static CONCILIATED = 'conciliated';
  static CANCELLED = 'cancelled';

  static colors = {
    [CaseInvoiceStatus.PENDING]: '#f97316',
    [CaseInvoiceStatus.CONCILIATED]: '#7e22ce',
    [CaseInvoiceStatus.CANCELLED]: '#ef4444',
  };

  static getColor(status) {
    return CaseInvoiceStatus.colors[status] || 'transparent';
  }

  static labels = {
    [CaseInvoiceStatus.PENDING]: 'Por conciliar',
    [CaseInvoiceStatus.CONCILIATED]: 'Conciliada',
  };

  static getLabel(status) {
    return CaseInvoiceStatus.labels[status] || 'Desconocido';
  }
}

// Estados de Cartas Avales (mirror backend).
// Ciclo interno: Recibido → Pendiente por Documento / Asesoría Médica /
// En Negociación → Autorizado / Rechazado → Entregado.
//
// Status público (lo que ven call_center y medical_center): Asesoría
// Médica y En Negociación se resumen como "pendiente" para no exponer
// complejidad interna al paciente/clínica (ver getPublicStatus).
export class LetterOfGuaranteeStatus {
  static RECEIVED = 'recibido';
  static PENDING_DOCUMENT = 'pendiente_documento';
  static MEDICAL_ADVICE = 'asesoria_medica';
  static IN_NEGOTIATION = 'en_negociacion';
  static APPROVED = 'autorizado';
  static REJECTED = 'rechazado';
  static DELIVERED = 'entregado';

  // Pseudo-estado público: agrupa los estados "en progreso" como En Proceso.
  // B2 (2026-09-22): renombrado de "Pendiente" a "En Proceso" para
  // alinearse con la card del header y evitar confusión con "Doc. Pend."
  // (que es el estado interno `pendiente_documento`).
  static PUBLIC_PENDIENTE = 'pendiente';

  static labels = {
    [LetterOfGuaranteeStatus.RECEIVED]: 'Recibido',
    [LetterOfGuaranteeStatus.PENDING_DOCUMENT]: 'Doc. Pend.',
    [LetterOfGuaranteeStatus.MEDICAL_ADVICE]: 'Asesoría Médica',
    [LetterOfGuaranteeStatus.IN_NEGOTIATION]: 'En Negociación',
    [LetterOfGuaranteeStatus.APPROVED]: 'Autorizado',
    [LetterOfGuaranteeStatus.REJECTED]: 'Rechazado',
    [LetterOfGuaranteeStatus.DELIVERED]: 'Entregado',
    [LetterOfGuaranteeStatus.PUBLIC_PENDIENTE]: 'En Proceso',
  };

  static colors = {
    // Paleta semántica de 4 colores. El color comunica ACCIÓN REQUERIDA
    // o RESULTADO, no el detalle burocrático de cada estado. Los 7
    // estados internos + el pseudo-estado público se agrupan así:
    //
    //   🟠 NARANJA OSCURO (#C0570F) — Atención / En proceso / Acción requerida
    //     · recibido (acaba de entrar, pendiente de revisión)
    //     · pendiente_documento (falta documento del paciente/clínica)
    //     · asesoria_medica (auditor la está evaluando)
    //     · en_negociacion (discutiendo costos)
    //     · public_pendiente (pseudo-estado que agrupa los 3 anteriores
    //                          para call_center / medical_center)
    //
    //   🟢 VERDE OSCURO (#3D6305) — Éxito / Finalizado positivo
    //     · autorizado (el seguro aprobó)
    //     · entregado (la carta ya se entregó al paciente)
    //
    //   🔴 ROJO (#e34242) — Alerta / Negativo / Detenido
    //     · rechazado (el seguro denegó)
    //
    //   🔵 AZUL — Reservado para UI interactiva (botones, links).
    //     NO se asigna a ningún estado burocrático para evitar saturar
    //     visualmente al operador (regla de UX empresarial: el color debe
    //     comunicar acción/urgencia, no estado detallado).
    [LetterOfGuaranteeStatus.RECEIVED]: '#C0570F',
    [LetterOfGuaranteeStatus.PENDING_DOCUMENT]: '#C0570F',
    [LetterOfGuaranteeStatus.MEDICAL_ADVICE]: '#C0570F',
    [LetterOfGuaranteeStatus.IN_NEGOTIATION]: '#C0570F',
    [LetterOfGuaranteeStatus.PUBLIC_PENDIENTE]: '#C0570F',
    [LetterOfGuaranteeStatus.APPROVED]: '#3D6305',
    [LetterOfGuaranteeStatus.DELIVERED]: '#3D6305',
    [LetterOfGuaranteeStatus.REJECTED]: '#e34242',
  };

  // Mapeo de status interno → status público.
  // Lo que ven call_center y medical_center; oculta la complejidad interna.
  // En Negociación se muestra tal cual a la clínica porque ES contraparte
  // de la negociación (necesita ver el status para poder responder con
  // presupuesto/condiciones). Master/doctor siguen viendo el interno completo.
  static PUBLIC_MAP = {
    [LetterOfGuaranteeStatus.RECEIVED]: LetterOfGuaranteeStatus.PUBLIC_PENDIENTE,
    [LetterOfGuaranteeStatus.MEDICAL_ADVICE]: LetterOfGuaranteeStatus.PUBLIC_PENDIENTE,
    [LetterOfGuaranteeStatus.IN_NEGOTIATION]: LetterOfGuaranteeStatus.IN_NEGOTIATION,
    [LetterOfGuaranteeStatus.PENDING_DOCUMENT]: LetterOfGuaranteeStatus.PENDING_DOCUMENT,
    [LetterOfGuaranteeStatus.APPROVED]: LetterOfGuaranteeStatus.APPROVED,
    [LetterOfGuaranteeStatus.REJECTED]: LetterOfGuaranteeStatus.REJECTED,
    [LetterOfGuaranteeStatus.DELIVERED]: LetterOfGuaranteeStatus.DELIVERED,
  };

  static getLabel(s) {
    return LetterOfGuaranteeStatus.labels[s] || s;
  }

  static getColor(s) {
    return LetterOfGuaranteeStatus.colors[s] || 'transparent';
  }

  /**
   * Retorna el status público para mostrar al paciente/clínica
   * (call_center, medical_center). Master recibe el status interno.
   */
  static getPublicStatus(internalStatus) {
    return LetterOfGuaranteeStatus.PUBLIC_MAP[internalStatus] || internalStatus;
  }

  /**
   * True si el status es solo visible para master (estado interno).
   * Útil para ocultar chips en listados según rol.
   */
  static isStaffOnly(status) {
    return (
      status === LetterOfGuaranteeStatus.MEDICAL_ADVICE ||
      status === LetterOfGuaranteeStatus.IN_NEGOTIATION
    );
  }

  /**
   * Helper principal para la UI: retorna el status VISUAL según rol.
   *
   *  - master: ve el status interno completo (7 códigos).
   *  - call_center / medical_center: ven un set agrupado
   *    (recibido / asesoria_medica / en_negociacion → "pendiente"),
   *    pendiente_documento, autorizado, rechazado, entregado.
   *
   * El backend siempre retorna el mismo `status` (sin campo public_status);
   * el frontend decide cómo se ve. Esto evita dos campos paralelos.
   */
  static getVisualStatus(internalStatus, role) {
    // Master, admin (vía is_superuser) y doctor ven el status interno
    // completo. Doctor necesita ver `asesoria_medica` /
    // `en_negociacion` para saber qué tipo de nota médica agregar.
    // El resto ve la versión pública agrupada (Pendiente macro).
    if (role === UserRole.MASTER || role === UserRole.DOCTOR) {
      return internalStatus;
    }
    return LetterOfGuaranteeStatus.getPublicStatus(internalStatus);
  }

  /**
   * Label visual según rol.
   */
  static getVisualLabel(internalStatus, role) {
    return LetterOfGuaranteeStatus.getLabel(
      LetterOfGuaranteeStatus.getVisualStatus(internalStatus, role)
    );
  }

  /**
   * Color visual según rol.
   */
  static getVisualColor(internalStatus, role) {
    return LetterOfGuaranteeStatus.getColor(
      LetterOfGuaranteeStatus.getVisualStatus(internalStatus, role)
    );
  }

  /**
   * Lista de status VISUALES para dropdowns / status cards según rol.
   * El orden sigue el flujo lógico del operador:
   *   - primero los estados en proceso (naranja),
   *   - luego el resultado positivo intermedio (verde),
   *   - luego el resultado negativo (rojo),
   *   - al final el resultado final (verde).
   *
   * master / admin (7 internos + agrupado):
   *   Recibido → Doc. Pend. → Asesoría Médica → En Negociación
   *   → Rechazado → Autorizado → Entregado
   *
   * call_center / medical_center (5 públicos):
   *   Pendiente → Doc. Pend. → Rechazado → Autorizado → Entregado
   *
   * (El item "Todos" se agrega en los consumers — getVisualStatuses
   *  devuelve solo los códigos.)
   */
  static getVisualStatuses(role) {
    if (role === UserRole.MASTER) {
      return [
        LetterOfGuaranteeStatus.RECEIVED,
        LetterOfGuaranteeStatus.PENDING_DOCUMENT,
        LetterOfGuaranteeStatus.MEDICAL_ADVICE,
        LetterOfGuaranteeStatus.IN_NEGOTIATION,
        LetterOfGuaranteeStatus.REJECTED,
        LetterOfGuaranteeStatus.APPROVED,
        LetterOfGuaranteeStatus.DELIVERED,
      ];
    }
    // B2 (2026-09-22): la clínica ve los 7 estados internos en
    // dropdowns (no el macro agrupado). Los estados `asesoria_medica`,
    // `en_negociacion` y `recibido` se renderizan en el chip con
    // label "En Proceso" via `getVisualLabel`, pero como código
    // siguen siendo los internos para que el filtro funcione.
    if (role === UserRole.MEDICAL_CENTER) {
      return [
        LetterOfGuaranteeStatus.RECEIVED,
        LetterOfGuaranteeStatus.PENDING_DOCUMENT,
        LetterOfGuaranteeStatus.MEDICAL_ADVICE,
        LetterOfGuaranteeStatus.IN_NEGOTIATION,
        LetterOfGuaranteeStatus.REJECTED,
        LetterOfGuaranteeStatus.APPROVED,
        LetterOfGuaranteeStatus.DELIVERED,
      ];
    }
    // call_center / otros: agrupado (Pendiente macro = 3 estados).
    return [
      LetterOfGuaranteeStatus.PUBLIC_PENDIENTE,
      LetterOfGuaranteeStatus.PENDING_DOCUMENT,
      LetterOfGuaranteeStatus.REJECTED,
      LetterOfGuaranteeStatus.APPROVED,
      LetterOfGuaranteeStatus.DELIVERED,
    ];
  }

  /**
   * Lista de status INTERNOS (7) — útil para backend filters.
   * Independiente del rol (los filtros al backend siempre van por código interno).
   */
  static getAllStatuses() {
    return [
      LetterOfGuaranteeStatus.RECEIVED,
      LetterOfGuaranteeStatus.PENDING_DOCUMENT,
      LetterOfGuaranteeStatus.MEDICAL_ADVICE,
      LetterOfGuaranteeStatus.IN_NEGOTIATION,
      LetterOfGuaranteeStatus.APPROVED,
      LetterOfGuaranteeStatus.REJECTED,
      LetterOfGuaranteeStatus.DELIVERED,
    ];
  }

  /**
   * Indica si el usuario puede ver el detalle interno (asesoria/negociacion)
   * o solo el visual agrupado.
   */
  static canSeeInternalStatuses(role) {
    return role === UserRole.MASTER;
  }
}

// Estados de Solicitudes de Reembolso (mirror backend, clase
// separada de LetterOfGuaranteeStatus aunque los codigos string
// coinciden). El reembolso es retroactivo: el paciente YA PAGÓ y
// pide reintegro. NO tiene flujo de asesoria medica del doctor
// (la factura fiscal ya tiene el diagnostico) ni de negociacion
// con la clinica (no hay dos partes negociando terminos).
// Por tanto:
//   - master / admin / call_center ven los 5 estados internos.
//   - nadie ve estados PUBLIC_PENDIENTE (no hay pseudo-estado publico).
export class ReimbursementStatus {
  static RECEIVED = 'recibido';
  static MEDICAL_ADVICE = 'asesoria_medica';
  static PENDING_DOCUMENT = 'pendiente_documento';
  static APPROVED = 'autorizado';
  static REJECTED = 'rechazado';
  static DELIVERED = 'entregado';

  static labels = {
    [ReimbursementStatus.RECEIVED]: 'Recibido',
    [ReimbursementStatus.MEDICAL_ADVICE]: 'Asesoría Médica',
    [ReimbursementStatus.PENDING_DOCUMENT]: 'Pendiente por Documento',
    [ReimbursementStatus.APPROVED]: 'Autorizado',
    [ReimbursementStatus.REJECTED]: 'Rechazado',
    [ReimbursementStatus.DELIVERED]: 'Entregado',
  };

  static colors = {
    [ReimbursementStatus.RECEIVED]: '#C0570F',
    [ReimbursementStatus.MEDICAL_ADVICE]: '#7c3aed',
    [ReimbursementStatus.PENDING_DOCUMENT]: '#C0570F',
    [ReimbursementStatus.APPROVED]: '#3D6305',
    [ReimbursementStatus.DELIVERED]: '#3D6305',
    [ReimbursementStatus.REJECTED]: '#e34242',
  };

  static getLabel(s) {
    return ReimbursementStatus.labels[s] || s;
  }

  static getColor(s) {
    return ReimbursementStatus.colors[s] || 'transparent';
  }

  /**
   * Lista de status para dropdowns / status cards. Solo se exponen
   * a master, admin (vía is_superuser) y call_center. El reembolso
   * no tiene pseudo-estado publico para doctor ni clinica.
   */
  static getAllStatuses() {
    return [
      ReimbursementStatus.RECEIVED,
      ReimbursementStatus.MEDICAL_ADVICE,
      ReimbursementStatus.PENDING_DOCUMENT,
      ReimbursementStatus.REJECTED,
      ReimbursementStatus.APPROVED,
      ReimbursementStatus.DELIVERED,
    ];
  }
}

// Rangos de severidad por monto (USD). Mirror de SeverityRange en backend.
// Definidos por el cliente (Roderick):
//   bajo:       0       ≤ x < 4.000
//   medio:      4.000   ≤ x < 7.800
//   alto:       7.800   ≤ x < 35.000  (Riesgo Alto)
//   gerencia:   x       ≥ 35.000      (Gerencia)
export class SeverityRange {
  static LOW = 'bajo';
  static MEDIUM = 'medio';
  static HIGH = 'alto';
  static MANAGEMENT = 'gerencia';

  static labels = {
    [SeverityRange.LOW]: 'Bajo',
    [SeverityRange.MEDIUM]: 'Medio',
    [SeverityRange.HIGH]: 'Riesgo Alto',
    [SeverityRange.MANAGEMENT]: 'Gerencia',
  };

  static colors = {
    [SeverityRange.LOW]: '#16a34a', // verde
    [SeverityRange.MEDIUM]: '#f59e0b', // amarillo
    [SeverityRange.HIGH]: '#ea580c', // naranja
    [SeverityRange.MANAGEMENT]: '#dc2626', // rojo
  };

  static getLabel(s) {
    return SeverityRange.labels[s] || s;
  }

  static getColor(s) {
    return SeverityRange.colors[s] || '#6b7280';
  }

  /**
   * Label compacto con el rango de dinero asociado, en formato corto
   * para los dropdowns de filtro (no para mostrar en celdas del Excel).
   * Formato: "Bajo · ≤4k", "Medio · 4-7.8k", "Riesgo Alto · 7.8-35k",
   * "Gerencia · >35k". Si el código no existe, cae al label simple.
   */
  static getCompactLabel(s) {
    const compact = {
      [SeverityRange.LOW]: 'Bajo · ≤4k',
      [SeverityRange.MEDIUM]: 'Medio · 4-7.8k',
      [SeverityRange.HIGH]: 'Riesgo Alto · 7.8-35k',
      [SeverityRange.MANAGEMENT]: 'Gerencia · >35k',
    };
    return compact[s] || SeverityRange.getLabel(s);
  }
}

// Categorías de documentos de Carta Aval. Mirror de DocumentCategory en backend.
export class DocumentCategory {
  static CI_TITULAR = 'ci_titular';
  static CI_PACIENTE = 'ci_paciente';
  static INFORME_MEDICO = 'informe_medico';
  static PRESUPUESTO = 'presupuesto';
  static EXAMEN = 'examen';
  static OTRO = 'otro';

  static labels = {
    [DocumentCategory.CI_TITULAR]: 'Cédula del titular',
    [DocumentCategory.CI_PACIENTE]: 'Cédula del paciente',
    [DocumentCategory.INFORME_MEDICO]: 'Informe médico',
    [DocumentCategory.PRESUPUESTO]: 'Presupuesto',
    [DocumentCategory.EXAMEN]: 'Examen',
    [DocumentCategory.OTRO]: 'Otro',
  };

  static icons = {
    [DocumentCategory.CI_TITULAR]: 'pi pi-id-card',
    [DocumentCategory.CI_PACIENTE]: 'pi pi-id-card',
    [DocumentCategory.INFORME_MEDICO]: 'pi pi-file-edit',
    [DocumentCategory.PRESUPUESTO]: 'pi pi-dollar',
    [DocumentCategory.EXAMEN]: 'pi pi-search-plus',
    [DocumentCategory.OTRO]: 'pi pi-file-pdf',
  };

  static getLabel(c) {
    return DocumentCategory.labels[c] || c;
  }

  static getIcon(c) {
    return DocumentCategory.icons[c] || 'pi pi-file';
  }

  static getAllCategories() {
    return [
      DocumentCategory.CI_TITULAR,
      DocumentCategory.CI_PACIENTE,
      DocumentCategory.INFORME_MEDICO,
      DocumentCategory.PRESUPUESTO,
      DocumentCategory.EXAMEN,
      DocumentCategory.OTRO,
    ];
  }
}

// Añadir clase para estados de estudios de imagenología
export class ImagingStudyStatus {
  static TO_INTERPRET = 'to_interpret';
  static TO_TRANSCRIBE = 'to_transcribe';
  static TO_APPROVE = 'to_approve';
  static APPROVED = 'approved';

  static colors = {
    [ImagingStudyStatus.TO_INTERPRET]: '#f59e0b', // amarillo
    [ImagingStudyStatus.TO_TRANSCRIBE]: '#0ea5e9', // azul
    [ImagingStudyStatus.TO_APPROVE]: '#7c3aed', // morado
    [ImagingStudyStatus.APPROVED]: '#16a34a', // verde
  };

  static labels = {
    [ImagingStudyStatus.TO_INTERPRET]: 'Pendiente de interpretación',
    [ImagingStudyStatus.TO_TRANSCRIBE]: 'Pendiente de transcripción',
    [ImagingStudyStatus.TO_APPROVE]: 'Pendiente de aprobación',
    [ImagingStudyStatus.APPROVED]: 'Aprobado',
  };

  static getColor(status) {
    return ImagingStudyStatus.colors[status] || '#6b7280'; // gris por defecto
  }

  static getLabel(status) {
    return ImagingStudyStatus.labels[status] || status || 'Desconocido';
  }
}

/**
 * Class of available user roles
 */
export class UserRole {
  static MASTER = 'master';
  static CONCILIATOR = 'conciliator';
  static AUDITOR = 'auditor';
  static MEDICAL_CENTER = 'medical_center';
  static IMAGENMED_CENTER = 'imagenmed_center';
  static ANALYST = 'analyst';
  static MANAGER = 'manager';
  static ANALYST_SUPPLIER = 'analyst_supplier';
  static ANALYST_COMPANY_CLIENT = 'analyst_company_client';
  static CALL_CENTER = 'call_center';
  static LABORATORY = 'laboratory';
  static SUB_ADMINISTRATOR = 'sub_administrator';
  static MEDICAL_CENTER_MASTER = 'medical_center_master';
  static DOCTOR = 'doctor'; // 👈 NUEVO ROL
  // Asegurado registrado desde el portal del asegurado. No se incluye en all()
  // porque no es un rol del personal del dashboard.
  static INSURED = 'insured';

  static all() {
    return [
      UserRole.MASTER,
      UserRole.CONCILIATOR,
      UserRole.IMAGENMED_CENTER,
      UserRole.AUDITOR,
      UserRole.MEDICAL_CENTER,
      UserRole.DOCTOR, // 👈 AGREGAR A LA LISTA
      UserRole.ANALYST,
      UserRole.MANAGER,
      UserRole.ANALYST_SUPPLIER,
      UserRole.ANALYST_COMPANY_CLIENT,
      UserRole.CALL_CENTER,
      UserRole.LABORATORY,
      UserRole.SUB_ADMINISTRATOR,
    ];
  }

  static readableName(role) {
    switch (role) {
      case UserRole.MASTER:
        return 'Master';
      case UserRole.CONCILIATOR:
        return 'Conciliador';
      case UserRole.AUDITOR:
        return 'Auditor';
      case UserRole.MEDICAL_CENTER:
        return 'Centro Médico';
      case UserRole.IMAGENMED_CENTER:
        return 'ImagenMed';
      case UserRole.DOCTOR: // 👈 NUEVO CASO
        return 'doctor';
      case UserRole.ANALYST:
        return 'Analista Regional';
      case UserRole.MANAGER:
        return 'Gerente General';
      case UserRole.ANALYST_SUPPLIER:
        return 'Analista de Centro Médico';
      case UserRole.ANALYST_COMPANY_CLIENT:
        return 'Analista de Cliente';
      case UserRole.CALL_CENTER:
        return 'Call Center';
      case UserRole.LABORATORY:
        return 'Laboratorio';
      case UserRole.SUB_ADMINISTRATOR:
        return 'Sub-Administrador';
      case UserRole.MEDICAL_CENTER_MASTER:
        return 'Master Centro Médico';
      default:
        return 'Desconocido';
    }
  }
}

const ROLE_TO_ROUTE = {
  [UserRole.MASTER]: '/casos',
  [UserRole.CONCILIATOR]: '/casos',
  [UserRole.AUDITOR]: '/auditorias',
  [UserRole.MEDICAL_CENTER]: '/casos',
  [UserRole.DOCTOR]: '/estudios/listado', // Ruta para interpretación de estudios
  [UserRole.ANALYST]: '/casos',
  [UserRole.MANAGER]: '/casos',
  [UserRole.ANALYST_SUPPLIER]: '/proveedores',
  [UserRole.ANALYST_COMPANY_CLIENT]: '/casos',
  [UserRole.CALL_CENTER]: '/casos',
  [UserRole.LABORATORY]: '/casos',
  [UserRole.SUB_ADMINISTRATOR]: '/casos',
};

/**
 * Class for fund types
 */
export class FundType {
  static PREPAY = 'prepay';
  static POSTPAY = 'postpay';

  static CHOICES = [
    { value: FundType.PREPAY, label: 'Prepago' },
    { value: FundType.POSTPAY, label: 'Postpago' },
  ];
}

export const getRouteForRole = role => {
  return ROLE_TO_ROUTE[role] || '/'; // Ruta por defecto si el rol no está definido
};

export const PAYMENTS_ROUTE = '/pagos/clientes';

/**
 * List of roles with allowed access per route
 */
export const ROUTE_ALLOWED_ROLES = {
  // Casos Médicos
  '/casos/nuevo': [
    UserRole.CONCILIATOR,
    UserRole.ANALYST,
    UserRole.MANAGER,
    UserRole.ANALYST_COMPANY_CLIENT,
    UserRole.CALL_CENTER,
    UserRole.LABORATORY,
    UserRole.MASTER,
  ],
  '/casos': [
    UserRole.CONCILIATOR,
    UserRole.MEDICAL_CENTER,
    UserRole.ANALYST,
    UserRole.MANAGER,
    UserRole.ANALYST_COMPANY_CLIENT,
    UserRole.CALL_CENTER,
    UserRole.ANALYST_SUPPLIER,
    UserRole.LABORATORY,
    UserRole.MASTER,
    UserRole.SUB_ADMINISTRATOR,
  ],
  '/ordenes-servicio/nueva': [UserRole.CALL_CENTER, UserRole.MASTER],
  '/ordenes-servicio': [UserRole.CALL_CENTER, UserRole.MASTER],
  '/casos/anulados': [
    UserRole.CONCILIATOR,
    UserRole.MEDICAL_CENTER,
    UserRole.ANALYST,
    UserRole.MANAGER,
    UserRole.ANALYST_COMPANY_CLIENT,
    UserRole.CALL_CENTER,
    UserRole.ANALYST_SUPPLIER,
    UserRole.LABORATORY,
    UserRole.MASTER,
    UserRole.SUB_ADMINISTRATOR,
  ],
  '/casos/por-suscribir': [UserRole.MANAGER, UserRole.CALL_CENTER, UserRole.MASTER],
  '/casos/carga-masiva': [UserRole.MASTER, UserRole.CALL_CENTER, UserRole.LABORATORY],
  '/casos/marcar-cobrado': [UserRole.SUB_ADMINISTRATOR],
  '/casos/audio': [UserRole.MASTER, UserRole.MEDICAL_CENTER],
  '/casos/patrones': [UserRole.MASTER, UserRole.MEDICAL_CENTER],
  '/casos/solicitudes-pendientes': [UserRole.MASTER, UserRole.CALL_CENTER, UserRole.LABORATORY],
  '/casos/:caseId/asignar-solicitud': [UserRole.MASTER, UserRole.CALL_CENTER, UserRole.LABORATORY],
  '/casos/facturacion-lotes': [
    UserRole.MEDICAL_CENTER,
    UserRole.LABORATORY,
    UserRole.SUB_ADMINISTRATOR,
  ],
  '/conciliar': [UserRole.MASTER],

  '/medicos': [UserRole.MEDICAL_CENTER],

  '/casos/por-suscribir/:caseId': [UserRole.MANAGER, UserRole.CALL_CENTER, UserRole.MASTER],
  '/casos/:caseId/reasignar': [UserRole.SUB_ADMINISTRATOR],
  '/casos/reasignados': [UserRole.SUB_ADMINISTRATOR],
  '/casos/reasignados/:caseId': [UserRole.SUB_ADMINISTRATOR],
  '/casos-pendientes': [UserRole.MEDICAL_CENTER, UserRole.SUB_ADMINISTRATOR],
  '/casos/:caseId': [
    UserRole.CONCILIATOR,
    UserRole.MEDICAL_CENTER,
    UserRole.ANALYST,
    UserRole.MANAGER,
    UserRole.ANALYST_COMPANY_CLIENT,
    UserRole.LABORATORY,
    UserRole.CALL_CENTER,
    UserRole.ANALYST_SUPPLIER,
    UserRole.MASTER,
    UserRole.SUB_ADMINISTRATOR,
  ],
  '/casos/:caseId/editar': [
    UserRole.CONCILIATOR,
    UserRole.MEDICAL_CENTER,
    UserRole.ANALYST,
    UserRole.MANAGER,
    UserRole.ANALYST_COMPANY_CLIENT,
    UserRole.LABORATORY,
    UserRole.CALL_CENTER,
    UserRole.ANALYST_SUPPLIER,
    UserRole.MASTER,
    UserRole.SUB_ADMINISTRATOR,
  ],
  '/aval': [UserRole.MASTER, UserRole.CALL_CENTER, UserRole.MEDICAL_CENTER, UserRole.DOCTOR],
  '/aval/nuevo': [UserRole.MASTER, UserRole.CALL_CENTER, UserRole.MEDICAL_CENTER],
  '/aval/:id': [UserRole.MASTER, UserRole.CALL_CENTER, UserRole.MEDICAL_CENTER, UserRole.DOCTOR],
  '/aval/:id/editar': [UserRole.MASTER],
  // Solicitudes de Reembolso. El reembolso es un tramite entre el
  // asegurado y el seguro: la clinica emite la factura fiscal pero
  // NO participa del flujo. El doctor (asesor del seguro) tampoco
  // porque ya hubo intervencion medica y el reembolso es un
  // tramite administrativo/financiero. Por tanto solo master,
  // admin (via is_superuser) y call_center.
  '/reembolso': [UserRole.MASTER, UserRole.CALL_CENTER],
  '/reembolso/nuevo': [UserRole.MASTER, UserRole.CALL_CENTER],
  '/reembolso/:id': [UserRole.MASTER, UserRole.CALL_CENTER],
  '/reembolso/:id/editar': [UserRole.MASTER],
  '/requerimientos': [],

  // Anticipos
  '/anticipos/nuevo': [
    UserRole.CONCILIATOR,
    UserRole.AUDITOR,
    UserRole.MASTER,
    UserRole.SUB_ADMINISTRATOR,
  ],
  '/anticipos': [
    UserRole.CONCILIATOR,
    UserRole.AUDITOR,
    // UserRole.CALL_CENTER,
    // UserRole.MEDICAL_CENTER,
    UserRole.MASTER,
    UserRole.SUB_ADMINISTRATOR,
  ],
  '/anticipos/proveedores/:centerId': [
    // UserRole.MEDICAL_CENTER,
    UserRole.CONCILIATOR,
    UserRole.AUDITOR,
    // UserRole.CALL_CENTER,
    UserRole.MASTER,
    UserRole.SUB_ADMINISTRATOR,
  ],

  // Baremos
  '/baremos': [
    UserRole.MASTER,
    UserRole.MEDICAL_CENTER,
    UserRole.SUB_ADMINISTRATOR,
    UserRole.LABORATORY,
  ],
  // La ruta real es '/baremos/cliente/:clientId' (se movió en el hotfix
  // ef2bcf56 para corregir la colisión con '/baremos/:baremoId'). La clave
  // anterior '/baremos/:clientId' ya no correspondía a ninguna ruta y dejaba
  // el detalle de baremo inaccesible para todo usuario que no sea superusuario.
  '/baremos/cliente/:clientId': [
    UserRole.MASTER,
    UserRole.MEDICAL_CENTER,
    UserRole.SUB_ADMINISTRATOR,
    UserRole.LABORATORY,
  ],
  '/baremos/imagenmed': [UserRole.MASTER, UserRole.MEDICAL_CENTER, UserRole.SUB_ADMINISTRATOR],
  '/baremos/sub-administradora/:subAdminId': [UserRole.SUB_ADMINISTRATOR, UserRole.MEDICAL_CENTER],
  '/baremos/nuevo': [
    UserRole.CONCILIATOR,
    UserRole.MANAGER,
    UserRole.AUDITOR,
    UserRole.ANALYST_SUPPLIER,
    UserRole.MASTER,
  ],
  '/baremos/:baremoId': [
    UserRole.CONCILIATOR,
    UserRole.MANAGER,
    UserRole.AUDITOR,
    UserRole.ANALYST_SUPPLIER,
    UserRole.MASTER,
  ],
  '/baremos/homologaciones': [UserRole.LABORATORY, UserRole.MEDICAL_CENTER, UserRole.CALL_CENTER],

  // Saldo
  '/saldo': [UserRole.MEDICAL_CENTER, UserRole.SUB_ADMINISTRATOR, UserRole.LABORATORY],
  '/pagos/clientes': [
    UserRole.MEDICAL_CENTER_MASTER,
    // TODO: Eliminar medical_center
    UserRole.MEDICAL_CENTER,
    UserRole.SUB_ADMINISTRATOR,
    UserRole.LABORATORY,
  ],
  '/pagos/clientes/:clientId': [
    UserRole.MEDICAL_CENTER_MASTER,

    UserRole.MEDICAL_CENTER,
    UserRole.SUB_ADMINISTRATOR,
    UserRole.LABORATORY,
  ],

  '/pagos/mdabroad-cobrar': [UserRole.MASTER, UserRole.MANAGER, UserRole.ANALYST_COMPANY_CLIENT],
  '/pagos/mdabroad-caso/:caseId': [
    UserRole.MASTER,
    UserRole.MANAGER,
    UserRole.ANALYST_COMPANY_CLIENT,
  ],

  '/pagos/detalle/:billingID': [
    UserRole.MEDICAL_CENTER_MASTER,
    UserRole.MEDICAL_CENTER,
    UserRole.SUB_ADMINISTRATOR,
    UserRole.LABORATORY,
  ],
  '/pagos/cuentas-por-pagar': [
    UserRole.MASTER,
    UserRole.MANAGER,
    UserRole.ANALYST_COMPANY_CLIENT,
    UserRole.SUB_ADMINISTRATOR,
  ],
  '/pagos/historial': [UserRole.MEDICAL_CENTER_MASTER, UserRole.MEDICAL_CENTER],
  '/pagos/checkout': [UserRole.MEDICAL_CENTER_MASTER, UserRole.MEDICAL_CENTER],

  // Proveedores
  '/proveedores': [
    // UserRole.CONCILIATOR,
    // UserRole.MEDICAL_CENTER,
    // UserRole.MANAGER,
    // UserRole.AUDITOR,
    // UserRole.ANALYST_SUPPLIER,
    // UserRole.MASTER
  ],
  '/proveedores/nuevo': [
    // UserRole.CONCILIATOR,
    // UserRole.MEDICAL_CENTER,
    // UserRole.MANAGER,
    // UserRole.AUDITOR,
    // UserRole.ANALYST_SUPPLIER,
    // UserRole.MASTER
  ],
  '/centro-medico/servicios': [
    UserRole.CONCILIATOR,
    // UserRole.MEDICAL_CENTER,
    UserRole.MANAGER,
    UserRole.AUDITOR,
    UserRole.ANALYST_SUPPLIER,
    UserRole.MASTER,
  ],
  '/proveedores/editar/:centerId': [
    // UserRole.CONCILIATOR,
    // UserRole.MEDICAL_CENTER,
    // UserRole.MANAGER,
    // UserRole.AUDITOR,
    // UserRole.ANALYST_SUPPLIER,
    // UserRole.MASTER
  ],

  // Facturas
  '/centro-medico/facturas': [],
  '/centro-medico/facturas/nueva': [],

  // Usuarios
  '/usuarios': [],
  '/permisos': [],
  '/usuarios/cliente': [],
  '/usuarios/permisos/:id': [],

  '/asegurados': [],

  '/reportes/casos-medicos': [],

  '/chat': UserRole.all(),

  // Logout
  '/logout': UserRole.all(),

  // API Generar token
  '/api/generar-token': [UserRole.MEDICAL_CENTER, UserRole.LABORATORY],

  // Nuevas Rutas Agregadas

  '/fondo-incurrido/crear-pago': [UserRole.MASTER, UserRole.SUB_ADMINISTRATOR],

  '/fondo-incurrido/abonos': [UserRole.MASTER, UserRole.SUB_ADMINISTRATOR],

  '/fondo-incurrido/abonos/proveedores/:centerId': [UserRole.MASTER, UserRole.SUB_ADMINISTRATOR],

  // Analíticas
  '/estadisticas': [UserRole.MEDICAL_CENTER, UserRole.LABORATORY],

  '/actualizaciones': [UserRole.MASTER],

  '/estudios/nuevo': [UserRole.MEDICAL_CENTER, UserRole.DOCTOR],

  '/estudios/create-imaging-study': [UserRole.MEDICAL_CENTER, UserRole.DOCTOR],
  '/estudios/create-audio-study': [UserRole.MEDICAL_CENTER, UserRole.DOCTOR],
  '/doctores/listado': [UserRole.MEDICAL_CENTER, UserRole.MASTER],
  '/doctorperfil': [UserRole.DOCTOR],
  '/doctores/listado/editar/:id': [UserRole.MEDICAL_CENTER, UserRole.MASTER],
  '/estudios/listado': [UserRole.MEDICAL_CENTER, UserRole.DOCTOR],
  '/estudios/pacientes': [UserRole.IMAGENMED_CENTER, UserRole.MEDICAL_CENTER],
  '/estudios/detail/:id': [UserRole.IMAGENMED_CENTER, UserRole.MEDICAL_CENTER, UserRole.DOCTOR],
  '/estudios/audio/:id': [UserRole.MEDICAL_CENTER, UserRole.DOCTOR],

  '/estudios/audioRecorder/:studyId': [
    UserRole.MEDICAL_CENTER,
    UserRole.DOCTOR,
    UserRole.IMAGENMED_CENTER,
  ],
  '/estudios/audio/:studyId': [UserRole.MEDICAL_CENTER, UserRole.DOCTOR],
  '/estudios/informe/:studyId': [UserRole.MEDICAL_CENTER, UserRole.MASTER, UserRole.DOCTOR],
};

/**
 * Permiso que habilita a ver la fila IMAGENMED en /baremos (y a entrar a
 * /baremos/imagenmed, la configuración de costos de ImagenMed).
 *
 * Se concede por rol (permission-roles.csv del backend) y se puede quitar por
 * usuario desde la gestión de permisos.
 */
export const IMAGENMED_COSTS_PERMISSION = 'dashboard:view:/baremos/imagenmed';

/**
 * Nombres de modalidades de estudios de imagenología
 */
export const MODALITY_NAMES = {
  CT: 'Tomografía Computarizada',
  MR: 'Resonancia Magnética',
  US: 'Ultrasonido',
  CR: 'Radiografía Computarizada',
  DX: 'Radiografía Digital',
  MG: 'Mamografía',
  PT: 'PET',
  NM: 'Medicina Nuclear',
  XA: 'Angiografía',
  RF: 'Fluoroscopia',
  OT: 'Otro',
  SM: 'Microscopía Digital',
  XC: 'Fotografía Clínica',
  OCT: 'Tomografía de Coherencia Óptica',
  RTIMAGE: 'Imagen de Radioterapia',
  RTDOSE: 'Dosis de Radioterapia',
  RTSTRUCT: 'Estructuras de Radioterapia',
};

/**
 * Initial form values for patient registration
 */
export const INITIAL_PATIENT_FORM = {
  ciType: 'V',
  ci: '',
  name: '',
  sex: null,
  birthDate: '',
  phoneCode: '58',
  phoneNumber: '',
  diagnosis: null,
  client: null,
  subsidiary: null,
  isHolder: true,
  shouldCreatePatient: false,
  minorId: '',
  isMinor: false,
  childNumber: null,
};

/**
 * Initial form values for holder registration
 */
export const INITIAL_HOLDER_FORM = {
  step: 1,
  isMdAbroad: false,
  ciType: 'V',
  ci: '',
  memberId: '',
  caseId: '',
  name: '',
  sex: null,
  birthDate: '',
  birthDay: null,
  birthMonth: null,
  birthYear: null,
  phoneCode: '58',
  phoneNumber: '',
  shouldCreateHolder: false,
  condition: 'A',
  optionalPhoneCode: '58',
  optionalPhoneNumber: '',
  patient: INITIAL_PATIENT_FORM,
  medicalOrder: null,
};

export const dashboardItems = [
  {
    label: 'Crear Nuevo',
    items: [
      {
        label: 'Crear caso',
        icon: 'pi pi-plus',
        url: '/casos/nuevo',
        user: ROUTE_ALLOWED_ROLES['/casos/nuevo'],
        active: [/\/casos\/nuevo/],
      },
      {
        label: 'Crear orden de servicio',
        icon: 'pi pi-plus',
        url: '/ordenes-servicio/nueva',
        user: ROUTE_ALLOWED_ROLES['/ordenes-servicio/nueva'],
        active: [/\/ordenes-servicio\/nueva/],
      },
      {
        label: 'Nueva Solicitud de Carta Aval',
        icon: 'pi pi-plus',
        url: '/aval/nuevo',
        user: ROUTE_ALLOWED_ROLES['/aval/nuevo'],
        active: [/\/aval\/nuevo/],
      },
      {
        label: 'Nueva Solicitud de Reembolso',
        icon: 'pi pi-plus',
        url: '/reembolso/nuevo',
        user: ROUTE_ALLOWED_ROLES['/reembolso/nuevo'],
        active: [/\/reembolso\/nuevo/],
      },
      {
        // La visibilidad depende SOLO del permiso 'dashboard:view:/casos/carga-masiva'.
        // Antes existía un atajo hardcodeado (clients: ['PDVSA', 'CVG Laboratorio'])
        // que mostraba el item aunque el permiso estuviera revocado; el guard de
        // ruta (ProtectedRoute) lo rechazaba y mandaba al usuario a /login.
        label: 'Carga masiva',
        icon: 'pi pi-upload',
        url: '/casos/carga-masiva',
        user: ROUTE_ALLOWED_ROLES['/casos/carga-masiva'],
        active: [/\/casos\/carga-masiva/],
      },
    ],
  },
  {
    label: 'Imagenología',
    items: [
      {
        label: 'Crear estudio',
        icon: 'pi pi-image',
        url: '/estudios/nuevo',
        user: ROUTE_ALLOWED_ROLES['/estudios/nuevo'] || ['ADMIN', 'MASTER'],
        active: [/\/estudios\/nuevo/],
      },
      {
        label: 'Listados estudios',
        icon: 'pi pi-image',
        url: '/estudios/listado',
        user: ROUTE_ALLOWED_ROLES['/estudios/listado'] || ['ADMIN', 'MASTER'],
        active: [/\/estudios\/listado/],
      },
      {
        label: 'Informes Listos',
        icon: 'pi pi-check-circle',
        url: '/estudios/informes-listos',
        permission: 'dashboard:view:/estudios/informes-listos',
      },
      {
        label: 'Pacientes',
        icon: 'pi pi-users',
        url: '/estudios/pacientes',
        permission: 'dashboard:view:/estudios/pacientes',
      },
      {
        label: 'Estadísticas',
        icon: 'pi pi-chart-bar',
        url: '/estudios/informes-metricas',
        permission: 'dashboard:view:/estudios/informes-metricas',
      },
      {
        // Solo superusuarios (ningún rol tiene este permiso asignado)
        label: 'Métricas ImagenMed',
        icon: 'pi pi-chart-line',
        url: '/estudios/metricas-imagenmed',
        permission: 'dashboard:view:/estudios/metricas-imagenmed',
      },
      {
        label: 'Configuracion',
        icon: 'pi pi-cog',
        url: '/estudios/equipos-centro-medico',
        permission: 'dashboard:view:/estudios/equipos-centro-medico',
      },
      {
        label: 'Dria',
        icon: 'pi pi-cog',
        url: '/dria',
        permission: 'dashboard:view:/dria',
      },
    ],
  },
  {
    label: 'Médicos Radiólogos',
    items: [
      {
        label: 'Listados de doctores',
        icon: 'pi pi-image',
        url: '/doctores/listado',
        user: ROUTE_ALLOWED_ROLES['/doctores/listado'] || ['ADMIN', 'MASTER', 'MEDICAL_CENTER'],
        active: [/\/doctores\/listado/],
      },
    ],
  },
  {
    label: 'Perfil',
    items: [
      {
        label: 'Mi Perfil',
        icon: 'pi pi-users',
        url: '/doctorperfil',
        user: ROUTE_ALLOWED_ROLES['/doctorperfil'] || ['ADMIN', 'MASTER', 'MEDICAL_CENTER'],
        active: [/\/doctorperfil/],
      },
    ],
  },

  {
    label: 'Casos Médicos',
    items: [
      {
        label: 'Asegurados',
        icon: 'pi pi-users',
        url: '/asegurados',
        user: ROUTE_ALLOWED_ROLES['/asegurados'],
      },
      {
        label: 'Listado de casos',
        icon: 'pi pi-list-check',
        url: '/casos',
        user: ROUTE_ALLOWED_ROLES['/casos'],
        active: [/\/casos\/\d+/],
      },
      {
        label: 'Listado de órdenes de servicio',
        icon: 'pi pi-list-check',
        url: '/ordenes-servicio',
        user: ROUTE_ALLOWED_ROLES['/ordenes-servicio'],
        active: [/\/ordenes-servicio\/\d+/],
      },
      {
        label: 'Casos anulados',
        icon: 'pi pi-list-check',
        url: '/casos/anulados',
        user: ROUTE_ALLOWED_ROLES['/casos/anulados'],
        active: [/\/casos\/anulados\/\d+/],
      },
      {
        label: 'Casos por suscribir',
        icon: 'pi pi-list-check',
        url: '/casos/por-suscribir',
        user: ROUTE_ALLOWED_ROLES['/casos/por-suscribir'],
        active: [/\/casos\/por-suscribir\/\d+/],
      },
      // {
      //   label: "Casos pendientes",
      //   icon: "pi pi-list-check",
      //   url: "/casos-pendientes",
      //   user: ROUTE_ALLOWED_ROLES["/casos-pendientes"],
      //   active: [/\/casos-pendientes\/\d+/],
      // },
      {
        label: 'Casos reasignados',
        icon: 'pi pi-list-check',
        url: '/casos/reasignados',
        user: ROUTE_ALLOWED_ROLES['/casos/reasignados'],
        active: [/\/casos\/reasignados\/\d+/],
      },
      {
        label: 'Solicitudes pendientes',
        icon: 'pi pi-list-check',
        url: '/casos/solicitudes-pendientes',
        user: ROUTE_ALLOWED_ROLES['/casos/solicitudes-pendientes'],
        active: [/\/casos\/solicitudes-pendientes\/\d+/],
      },
      {
        label: 'Solicitudes de Carta Aval',
        icon: 'pi pi-envelope',
        url: '/aval',
        user: ROUTE_ALLOWED_ROLES['/aval'],
        active: [/\/aval(\/|$)/],
      },
      {
        label: 'Solicitudes de Reembolso',
        icon: 'pi pi-wallet',
        url: '/reembolso',
        user: ROUTE_ALLOWED_ROLES['/reembolso'],
        active: [/\/reembolso(\/|$)/],
      },
      {
        label: 'Facturación en lotes',
        icon: 'pi pi-receipt',
        url: '/casos/facturacion-lotes',
        user: ROUTE_ALLOWED_ROLES['/casos/facturacion-lotes'],
        active: [/\/casos\/facturacion-lotes\/\d+/],
      },
      {
        label: 'Conciliar facturas',
        icon: 'pi pi-receipt',
        url: '/conciliar',
        user: ROUTE_ALLOWED_ROLES['/conciliar'],
        active: [/\/conciliar\/\d+/],
      },
    ],
  },
  {
    label: 'Médicos',
    items: [
      {
        label: 'Médicos a bordo',
        icon: 'pi pi-users',
        url: '/medicos',
        user: ROUTE_ALLOWED_ROLES['/medicos'],
      },
    ],
  },
  {
    label: 'Anticipos',
    items: [
      {
        label: 'Crear anticipo',
        icon: 'pi pi-plus',
        url: '/anticipos/nuevo',
        user: ROUTE_ALLOWED_ROLES['/anticipos/nuevo'],
      },
      {
        label: 'Anticipos',
        icon: 'pi pi-wallet',
        url: '/anticipos',
        user: ROUTE_ALLOWED_ROLES['/anticipos'],
        active: [/\/anticipos\/proveedores\/\d+/],
      },
    ],
  },
  {
    label: 'Abonos',
    items: [
      {
        label: 'Crear pago',
        icon: 'pi pi-plus',
        url: '/fondo-incurrido/crear-pago',
        user: ROUTE_ALLOWED_ROLES['/fondo-incurrido/crear-pago'],
      },
      {
        label: 'Abonos',
        icon: 'pi pi-wallet',
        url: '/fondo-incurrido/abonos',
        user: ROUTE_ALLOWED_ROLES['/fondo-incurrido/abonos'],
        active: [/\/fondo-incurrido\/abonos\/\d+/],
      },
    ],
  },
  {
    label: 'Baremos',
    items: [
      {
        label: 'Baremos',
        icon: 'pi pi-percentage',
        url: '/baremos',
        user: ROUTE_ALLOWED_ROLES['/baremos'],
        active: [/\/baremos\/\d+/],
      },
      {
        label: 'Requerimientos médicos',
        icon: 'pi pi-file-edit',
        url: '/requerimientos',
        user: ROUTE_ALLOWED_ROLES['/requerimientos'],
      },
      {
        label: 'Homologaciones',
        icon: 'pi pi-sitemap',
        url: '/baremos/homologaciones',
        user: ROUTE_ALLOWED_ROLES['/baremos/homologaciones'],
      },
    ],
  },
  // Oculto del menú: "Saldo disponible" correspondía al manejo de PDVSA por fondos,
  // donde el centro médico podía consultar el saldo que le quedaba a favor. Actualmente
  // el manejo es prepago, por lo que este módulo no se está usando. No se marca como
  // @deprecated porque podría volver a necesitarse si se retoma el manejo por fondos.
  // {
  //   label: 'Saldo',
  //   items: [
  //     {
  //       label: 'Saldo disponible',
  //       icon: 'pi pi-wallet',
  //       url: '/saldo',
  //       user: ROUTE_ALLOWED_ROLES['/saldo'],
  //       active: [/\/saldo\/\d+/],
  //     },
  //   ],
  // },
  {
    label: 'Pagos',
    items: [
      {
        label: 'Cuentas por Cobrar',
        icon: 'pi pi-credit-card',
        url: '/pagos/clientes',
        user: ROUTE_ALLOWED_ROLES['/pagos/clientes'],
      },
      {
        label: 'Cuentas por Pagar',
        icon: 'pi pi-wallet',
        url: '/pagos/cuentas-por-pagar',
        user: ROUTE_ALLOWED_ROLES['/pagos/cuentas-por-pagar'],
      },
    ],
  },
  {
    label: 'Estadísticas',
    items: [
      {
        label: 'Estadísticas',
        icon: 'pi pi-chart-line',
        url: '/estadisticas',
        user: ROUTE_ALLOWED_ROLES['/estadisticas'],
        active: [/\/estadisticas\/\d+/],
      },
    ],
  },
  // {
  //   label: "API",
  //   items: [
  //     {
  //       label: "Descargar TOKEN",
  //       icon: "pi pi-download",
  //       url: "/api/generar-token",
  //       user: ROUTE_ALLOWED_ROLES["/api/generar-token"],
  //     },
  //   ],
  // },
  // @deprecated Módulo "Listado de Proveedores" ya no está en uso, se oculta del menú.
  // Autor: Cesar Barreto <barretocesar33@gmail.com>
  // Fecha: 2026-09-16
  // {
  //   label: 'Proveedores',
  //   items: [
  //     {
  //       label: 'Listado de Proveedores',
  //       icon: 'pi pi-building-columns',
  //       url: '/proveedores',
  //       user: ROUTE_ALLOWED_ROLES['/proveedores'],
  //       active: [/\/proveedores\/nuevo/, /\/proveedores\/editar\/\d+/],
  //     },
  //   ],
  // },
  // {
  //   label: "Facturas",
  //   items: [
  //     {
  //       label: "Cargar factura",
  //       icon: "pi pi-plus",
  //       url: "/centro-medico/facturas/nueva",
  //       user: ROUTE_ALLOWED_ROLES["/centro-medico/facturas/nueva"],
  //     },
  //     {
  //       label: "Listado de facturas",
  //       icon: "pi pi-receipt",
  //       url: "/centro-medico/facturas",
  //       user: ROUTE_ALLOWED_ROLES["/centro-medico/facturas"],
  //     },
  //   ],
  // },

  {
    label: 'Usuarios',
    items: [
      // {
      //   label: 'Listado de usuarios',
      //   icon: 'pi pi-users',
      //   url: '/usuarios',
      //   user: ROUTE_ALLOWED_ROLES['/usuarios'],
      // },
      // {
      //   label: 'Usuarios cliente',
      //   icon: 'pi pi-users',
      //   url: '/usuarios/cliente',
      //   user: ROUTE_ALLOWED_ROLES['/usuarios/cliente'],
      // },
      {
        label: 'Permisos',
        icon: 'pi pi-lock',
        url: '/permisos',
        user: ROUTE_ALLOWED_ROLES['/permisos'],
      },
    ],
  },
  {
    label: 'Configuración',
    items: [
      {
        label: 'Colectivos',
        icon: 'pi pi-cog',
        url: '/colectivos',
        user: ROUTE_ALLOWED_ROLES['/colectivos'],
        active: [/\/colectivos\/\d+/],
      },
      {
        label: 'Actualizaciones',
        icon: 'pi pi-sync',
        url: '/actualizaciones',
        user: ROUTE_ALLOWED_ROLES['/actualizaciones'],
      },
      {
        label: 'Sincronización CSV',
        icon: 'pi pi-refresh',
        url: '/admin/sync-csv',
        user: ROUTE_ALLOWED_ROLES['/admin/sync-csv'],
      },
    ],
  },
  // Oculto del menú: "Casos médicos" no se está utilizando actualmente.
  // {
  //   label: 'Reportes',
  //   items: [
  //     {
  //       label: 'Casos médicos',
  //       icon: 'pi pi-list-check',
  //       url: '/reportes/casos-medicos',
  //       user: ROUTE_ALLOWED_ROLES['/reportes/casos-medicos'],
  //     },
  //   ],
  // },
  {
    label: 'Chat',
    items: [
      {
        label: 'Chat',
        icon: 'pi pi-comments',
        url: '/chat',
        user: ROUTE_ALLOWED_ROLES['/chat'],
      },
    ],
  },
];

export const BATCH_INVOICE_DRAFT_STORAGE_KEY = 'batchInvoiceDraft';

export const phoneAreaCodes = [
  // Norteamérica
  { label: 'Estados Unidos (+1)', value: '+1' },
  { label: 'Canadá (+1)', value: '+1' },
  { label: 'México (+52)', value: '+52' },
  // Centroamérica
  { label: 'Guatemala (+502)', value: '+502' },
  { label: 'Honduras (+504)', value: '+504' },
  { label: 'El Salvador (+503)', value: '+503' },
  { label: 'Nicaragua (+505)', value: '+505' },
  { label: 'Costa Rica (+506)', value: '+506' },
  { label: 'Panamá (+507)', value: '+507' },
  // Sudamérica
  { label: 'Venezuela (+58)', value: '+58' },
  { label: 'Colombia (+57)', value: '+57' },
  { label: 'Argentina (+54)', value: '+54' },
  { label: 'Perú (+51)', value: '+51' },
  { label: 'Chile (+56)', value: '+56' },
  { label: 'Ecuador (+593)', value: '+593' },
  { label: 'Bolivia (+591)', value: '+591' },
  { label: 'Paraguay (+595)', value: '+595' },
  { label: 'Uruguay (+598)', value: '+598' },
  { label: 'Brasil (+55)', value: '+55' },
  // Europa
  { label: 'España (+34)', value: '+34' },
  { label: 'Reino Unido (+44)', value: '+44' },
  { label: 'Francia (+33)', value: '+33' },
  { label: 'Alemania (+49)', value: '+49' },
  { label: 'Italia (+39)', value: '+39' },
  { label: 'Portugal (+351)', value: '+351' },
];

export const API_VERSION_PREFIX = { v1: 'api/v1/', v2: 'api/v2/' };
export const getBaseUrl = (version = 'v1') =>
  `${import.meta.env.VITE_API_HOST}/${API_VERSION_PREFIX[version]}`;
